import { ref } from 'vue';
import { getContactPreview, } from '../infrastructure/adapters/contactService';
import { logger } from '../../../infrastructure/services/LoggerService';
export function useContactPreview() {
    const showPreviewDrawer = ref(false);
    const previewContact = ref(null);
    const previewContactId = ref('');
    const previewLoading = ref(false);
    const previewError = ref(null);
    async function fetchPreview(id) {
        previewContactId.value = id;
        previewContact.value = null;
        previewError.value = null;
        previewLoading.value = true;
        try {
            previewContact.value = await getContactPreview(id);
        }
        catch (error) {
            logger.error('Failed to load contact preview', error);
            previewError.value = 'contact.create.preview.error';
        }
        finally {
            previewLoading.value = false;
        }
    }
    async function retryPreview() {
        if (previewContactId.value)
            await fetchPreview(previewContactId.value);
    }
    function reset() {
        showPreviewDrawer.value = false;
        previewContact.value = null;
        previewContactId.value = '';
        previewLoading.value = false;
        previewError.value = null;
    }
    return { showPreviewDrawer, previewContact, previewContactId, previewLoading, previewError, fetchPreview, retryPreview, reset };
}
